// src/services/rentalService.js
// Helpers for reading/writing rentals and checking access windows

import { doc, getDoc, setDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function getUserRental(uid, eventId) {
  if (!uid || !eventId) return null;
  const ref = doc(db, "users", uid, "rentals", eventId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export function isRentalActive(rental, now = new Date()) {
  if (!rental || rental.status !== "active" || !rental.accessEnd) return false;
  const end = rental.accessEnd?.toDate ? rental.accessEnd.toDate() : new Date(rental.accessEnd);
  return end > now;
}

/**
 * Write a successful rental under /users/{uid}/rentals/{eventId}
 * accessStart is serverTimestamp(), accessEnd = clientNow + rentalDays
 */
export async function addUserRental({ uid, event, capture, currency = "USD" }) {
  if (!uid) throw new Error("Missing uid");
  if (!event?.id) throw new Error("Missing event.id");
  if (!event?.price && event?.price !== 0) throw new Error("Missing event.price");

  const rentalDays =
    typeof event?.rentalDays === "number" && event.rentalDays > 0 ? event.rentalDays : 1;

  const accessStartClient = new Date();
  const accessEndClient = new Date(accessStartClient.getTime() + rentalDays * 24 * 60 * 60 * 1000);

  const rentalRef = doc(db, "users", uid, "rentals", event.id);

  const payload = {
    eventId: event.id,
    eventTitle: event.title || "",
    price: Number(event.price),
    currency,
    rentalDays,
    status: "active",
    accessStart: serverTimestamp(),
    accessEnd: Timestamp.fromDate(accessEndClient),
    createdAt: serverTimestamp(),
    paypal: capture
      ? {
          orderId: capture.id || null,
          intent: capture.intent || "CAPTURE",
          status: capture.status || "COMPLETED",
          payerId: capture?.payer?.payer_id || null,
          amount: capture?.purchase_units?.[0]?.payments?.captures?.[0]?.amount || null,
          raw: capture,
        }
      : null,
  };

  await setDoc(rentalRef, payload, { merge: true });
  return payload;
}
